
import { apiAxios } from "../../../../utils/apiAxios";

/* ================= ENV ================= */
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/* ================= DTO ================= */
export interface ManagerDashboardCountsDto {
  activeOrders: number;
  awaitingResponse: number;
  needAttention: number;
  completed: number;
  onTime:number,
  cancelled:number
}

/* ================= API RESPONSE ================= */
interface ApiResponse<T> {
  isSuccess: boolean;
  statusCode: number;
  status: string;
  singleData: T;
  errors?: string[];
}

/* ================= API CALL ================= */
export const GetCentralDashboardCounts = async (): Promise<
  ApiResponse<ManagerDashboardCountsDto>
> => {
  const response = await apiAxios.get<
    ApiResponse<ManagerDashboardCountsDto>
    >(`${API_BASE}/Central/dashboard-counts`);
 // >(`${API_BASE}/Manager/manager/dashboard-counts`);

  return response.data;
};
